import { render, staticRenderFns } from "./homeNews.vue?vue&type=template&id=6617e2f8&scoped=true&"
import script from "./homeNews.vue?vue&type=script&lang=js&"
export * from "./homeNews.vue?vue&type=script&lang=js&"
import style0 from "./homeNews.vue?vue&type=style&index=0&id=6617e2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617e2f8",
  null
  
)

export default component.exports